import React from "react";
import { Phone, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function Heroheader() {
  return <section data-section-id="262757" id="heroheader" className="relative bg-background text-foreground py-24 md:py-32 lg:py-40 overflow-hidden flex items-center justify-center min-h-[70vh]">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-secondary/10 to-transparent pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center">
        <Badge variant="outline" className="mb-8 border-secondary/30 bg-secondary/10 text-secondary hover:bg-secondary/20 text-sm py-2 px-5 rounded-md backdrop-blur-sm shadow-sm uppercase tracking-widest font-default font-bold">
          <Clock className="w-4 h-4 mr-2" />
          LEGAL
        </Badge>

        <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold mb-6 max-w-4xl leading-tight tracking-tight text-foreground">
          Privacy Policy
        </h1>

        <p className="font-default text-lg md:text-xl text-muted-foreground mb-10 max-w-3xl mx-auto leading-relaxed">
          Your privacy is important to us. This policy outlines how BlinkLab Media collects, 
          uses, and protects your personal information across our digital platforms 
          and services.
        </p>

        <div className="flex flex-col items-center gap-4">
          <div className="w-24 h-1 bg-secondary mb-6 rounded-md" />
          
          <p className="text-sm text-muted-foreground font-default font-medium mt-3">
            Last Updated: May 22, 2024 — BlinkLab Media, A Division of BL Events LLC
          </p>
        </div>
      </div>
    </section>;
}